
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g2_45Q_45dGAJh6Seehal8kYSbWaNx9MMM0fqC_cv_EI_0wYMeta } from "/codebuild/output/src1049007172/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexZ_KyiLqjYD_45FPqe0x9nP4q27Nrnp3gCYddmS5FSnl_sMeta } from "/codebuild/output/src1049007172/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as search1bfGyTZMHNQVerspirqlDjSDWYsFZhsd1fdttfu8isMMeta } from "/codebuild/output/src1049007172/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexY815fbCI6fHpNOeKqSKy9xh818YfJCuqUpv_Os5NelIMeta } from "/codebuild/output/src1049007172/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93eR_DBt71A2vLIumixpWVEy17yDTs2xESpdH0DwXB8PsMeta } from "/codebuild/output/src1049007172/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexA6lzYqaSwHQlUeYtyTXn6cq3L2CZ6XD5_452oAKsW6Cw4Meta } from "/codebuild/output/src1049007172/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93rgOGFjWvzffYANS64w8Q4ZNkbhNbrotb_VNE9KFemawMeta } from "/codebuild/output/src1049007172/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexD6_45nMCchc4HROrlkMBIgQtJFumidiJHBVSFqsH2CMkcMeta } from "/codebuild/output/src1049007172/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_937eJ9Tgtoeiul7mQMfUHAbVUEyHIdj400Rlhm5qGqVJQMeta } from "/codebuild/output/src1049007172/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexUNZieAVBMFy_owULTDjb5nNY0ci16b0QM_45LvKe9SJW8Meta } from "/codebuild/output/src1049007172/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as index_qWU_s1OJ65k3vnQfOkiMD3ru8PqsNeRt2vSeQok0fQMeta } from "/codebuild/output/src1049007172/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1049007172/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1049007172/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1049007172/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1049007172/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1049007172/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexA6lzYqaSwHQlUeYtyTXn6cq3L2CZ6XD5_452oAKsW6Cw4Meta || {},
    component: () => import("/codebuild/output/src1049007172/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1049007172/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexD6_45nMCchc4HROrlkMBIgQtJFumidiJHBVSFqsH2CMkcMeta || {},
    component: () => import("/codebuild/output/src1049007172/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1049007172/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexUNZieAVBMFy_owULTDjb5nNY0ci16b0QM_45LvKe9SJW8Meta || {},
    component: () => import("/codebuild/output/src1049007172/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: index_qWU_s1OJ65k3vnQfOkiMD3ru8PqsNeRt2vSeQok0fQMeta || {},
    component: () => import("/codebuild/output/src1049007172/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]